module.exports = __webpack_public_path__ + "img/top_img.1404041d.png";